import React from 'react';
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types';

function BasePage({ children }) {
  return (
    <>
      <MetaTags>
        <title>Privacy Acceptance Form</title>
        <link
          rel="stylesheet"
          href="https://maxcdn.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css"
          integrity="sha384-9aIt2nRpC12Uk9gS9baDl411NQApFmC26EwAOH8WgZl5MYYxFfc+NcPb1dKGj7Sk"
          crossOrigin="anonymous"
        />
      </MetaTags>
      {children}
    </>
  );
}

BasePage.defaultProps = {
  children: {},
};

BasePage.propTypes = {
  children: PropTypes.node,
};

export default BasePage;
